import { render } from "./MyActivityPage.vue?vue&type=template&id=d2d04af2&scoped=true"
import script from "./MyActivityPage.vue?vue&type=script&lang=js"
export * from "./MyActivityPage.vue?vue&type=script&lang=js"

import "./MyActivityPage.vue?vue&type=style&index=0&id=d2d04af2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d04af2"]])

export default __exports__